import Pagination from "@mui/material/Pagination";
import React, { useEffect, useState } from "react";
import PreviewFooter from "../Preview/PreviewFooter/PreviewFooter";
import PreviewHeader from "../Preview/PreviewHeader/PreviewHeader";
import PreviewQuestions from "../Preview/PreviewQuestions/PreviewQuestions";

import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import Error from "../../screen/Error/Error";
import { getPageCount, getPagesAnswers } from "../../services/ApiServices";
import Loader from "../Loader/Loader";
export default function AnswersPages({ id }) {
  const [survey, setsurvey] = useState(null);
  const [pagenation, setpagenation] = useState(1);
  const { data: page } = useQuery(
    ["getPageCount"],
    getPageCount.bind(null, id),
    {
      onError: (_) => {
        toast.error("Sayfa sayıları getiriliken hata oluştu.");
      },
    }
  );

  useEffect(() => {
    mutation.mutate({ SurveyID: id, page: 0 });
  }, []);

  const mutation = useMutation(getPagesAnswers, {
    onSuccess: (value) => {
      setsurvey(value);
    },
    onError: (_) => {
      toast.error("Anketin cevaplerı getiriliken hata oluştu.");
    },
  });

  if (mutation.isLoading) {
    return <Loader />;
  }

  if (mutation.isError) {
    return (
      <Error
        error={mutation.error.message}
        code={mutation.error.request.status}
        text={"Giriş Ekranına Geri Dön "}
        historylink={"/"}
      />
    );
  }

  function OnChangePageNation(value) {
    setpagenation(value);
    mutation.mutate({ SurveyID: id, page: value - 1 });
  }

  return (
    <>
     <div className="bg-white items-center flex justify-center p-3 border-2 my-4 flex-col lg:min-w-[78rem] lg:max-w-[78rem] md:min-w-[47rem] md:max-w-[47rem] w-full">
        <Pagination
          count={!!page ? page.data.answer_count : 0}
          onChange={(e, value) => OnChangePageNation(value)}
          variant="outlined"
          shape="rounded"
          page={pagenation}
        />
      </div>
      {!!survey ? (
        <div className="lg:max-w-[78rem] md:max-w-[47rem] w-full bg-white items-center flex justify-center p-3 border-2 my-4 flex-col">
          {/* <PreviewHeader
            title={survey.data.survey_title}
            description={survey.data.survey_description}
            id={id}
          /> */}

          {survey.data.questions.map((element, index) => {
            return (
              <div className="w-full" key={index}>
                <PreviewQuestions
                  index={index}
                  title={element.question_title}
                  description={element.question_description}
                  options={element.question_options}
                  tpye={element.question_type}
                  emoji={element.question_emoji}
                  firstEmojiUrl={element.question_firstEmojiUrl}
                  secondEmojiUrl={element.question_secondEmojiUrl}
                  answers={element.answer_value}
                  bgrequired={true}
                />
              </div>
            );
          })}

          {/* <PreviewFooter /> */}
        </div>
      ) : (
        ""
      )}
    </>
  );
}
